import { render } from "./DonationDialog.vue?vue&type=template&id=0e881a25&scoped=true"
import script from "./DonationDialog.vue?vue&type=script&lang=js"
export * from "./DonationDialog.vue?vue&type=script&lang=js"

import "./DonationDialog.vue?vue&type=style&index=0&id=0e881a25&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e881a25"]])

export default __exports__